export default {
    start: 'casino-home',
    process: require('./../process/casino').default
}



// WEBPACK FOOTER //
// ./src/processes/conf/casino.js